// Cache Busting Utility
// Add this to your main HTML to force reload on new deployments

export const BUILD_VERSION = '2.0.0'; // INCREMENT THIS ON EVERY DEPLOY

// Check if version has changed and force reload
export function checkVersion() {
  const storedVersion = localStorage.getItem('app_version');
  
  if (storedVersion && storedVersion !== BUILD_VERSION) {
    console.log(`[Cache Buster] Version changed from ${storedVersion} to ${BUILD_VERSION}`);
    console.log('[Cache Buster] Clearing caches and reloading...');
    
    // Clear all caches
    if ('caches' in window) {
      caches.keys().then((cacheNames) => {
        return Promise.all(
          cacheNames.map((cacheName) => caches.delete(cacheName))
        );
      }).then(() => {
        // Update version
        localStorage.setItem('app_version', BUILD_VERSION);
        // Force reload
        window.location.reload(true);
      });
    } else {
      localStorage.setItem('app_version', BUILD_VERSION);
      window.location.reload(true);
    }
  } else if (!storedVersion) {
    // First time load
    localStorage.setItem('app_version', BUILD_VERSION);
  }
}

// Add timestamp to asset URLs to prevent caching
export function bustCache(url) {
  const timestamp = new Date().getTime();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${BUILD_VERSION}&t=${timestamp}`;
}

// Force clear all caches (emergency button)
export function emergencyClearCache() {
  console.log('[Cache Buster] EMERGENCY CACHE CLEAR');
  
  // Clear service worker caches
  if ('caches' in window) {
    caches.keys().then((cacheNames) => {
      return Promise.all(
        cacheNames.map((cacheName) => {
          console.log('[Cache Buster] Deleting cache:', cacheName);
          return caches.delete(cacheName);
        })
      );
    });
  }
  
  // Clear localStorage
  localStorage.clear();
  
  // Clear sessionStorage
  sessionStorage.clear();
  
  // Unregister service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }
  
  // Force hard reload
  setTimeout(() => {
    window.location.reload(true);
  }, 500);
}
